export default {
    wss: 'wss://reelshortbiz.com/ws',
    host: 'https://reelshortbiz.com',
    web_host: 'https://wap.reelshortbiz.com',
}